export class AmministrazioneDTO {
  codice: string;
  nomeEsteso: string;
  codiceFiscale: string;
}
